
(() => {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const mediaSrc = v => v && (v.dataset.src || v.getAttribute('src') || '');
  const loadVideo = v => {
    if(!v || v.getAttribute('src') || !v.dataset.src) return;
    v.setAttribute('src', v.dataset.src);
    v.load();
  };
  const unloadVideo = v => {
    if(!v || !v.getAttribute('src')) return;
    v.pause();
    try { v.currentTime=0; } catch(e){}
    v.removeAttribute('src');
    v.load();
  };
  const safePlay = (v, denied) => {
    if(!v) return Promise.resolve();
    loadVideo(v);
    const p=v.play();
    return p&&p.catch ? p.catch(err=>{ if(denied) denied(err); }) : Promise.resolve();
  };

  /* ---------- pricing ---------- */
  const SP = window.SP || {};
  const PRICES = SP.prices;
  const BUNDLE = SP.bundle;
  const RAZORS = ['black','silver','ss'];
  const NAMES = SP.names;
  const IMGS = SP.img;
  const hasRazor = () => RAZORS.some(k => cart.get(k));
  const unit = k => (BUNDLE[cur][k] !== undefined && hasRazor()) ? BUNDLE[cur][k] : PRICES[cur][k];
  let cur = 'USD';
  try { cur = localStorage.getItem('sp-cur') || 'USD'; } catch(e){}
  const money = n => `$${n.toFixed(2)} ${cur}`;
  const short = n => `$${Number.isInteger(n)?n:n.toFixed(2)} ${cur}`;
  const P = k => (SP.priceText && SP.priceText[k]) || short(PRICES[cur][k]);
  function paintPrices(){
    $$('[data-price]').forEach(el => { const k=el.dataset.price; el.textContent = BUNDLE[cur][k]!==undefined ? short(BUNDLE[cur][k]) : P(k); });
    $$('[data-price-was]').forEach(el => el.textContent = short(PRICES[cur][el.dataset.priceWas]));
    if($('#announce')) $('#announce').innerHTML = SP.announce[cur];
    $$('.currency button').forEach(b => { const on = b.dataset.cur===cur; b.classList.toggle('on',on); b.setAttribute('aria-pressed',on); });
    if(sel){ $('#finalPrice').textContent = P(sel); $('#bbPrice').textContent = P(sel); }
    else { $('#finalPrice').textContent = ''; $('#bbPrice').textContent = ''; }
    paintBB();
    if($('#addBlades')) $('#addBlades').textContent = `${SP.t.add_blades} \u00b7 ${short(hasRazor()?BUNDLE[cur].blades:PRICES[cur].blades)}`;
    renderCart();
  }
  $$('.currency button').forEach(b => b.addEventListener('click', () => { cur=b.dataset.cur; try{localStorage.setItem('sp-cur',cur)}catch(e){} paintPrices(); }));

  /* ---------- selected finish ---------- */
  let sel = null;
  function paintBB(){
    const b=$('#bbAdd'), desk=$('#bbAdd .bbl'), mob=$('#bbAdd .bbm'); if(!b) return;
    if(!sel){ const label=b.dataset.chooseLabel||'Choose your finish'; if(desk) desk.textContent=label; if(mob) mob.textContent=label; return; }
    if(desk) desk.textContent=b.dataset.addLabel||SP.t.add;
    if(mob) mob.textContent=(b.dataset.addLabelShort||SP.t.add)+' \u00b7 '+P(sel);
  }
  function setSel(f){
    sel = f;
    $$('.card').forEach(c => c.classList.toggle('selected', c.dataset.finish===f));
    $$('.swatch').forEach(s => { const on=s.dataset.f===f; s.classList.toggle('on',on); s.setAttribute('aria-pressed',on); });
    $('#buybar').classList.remove('awaiting'); $('#bbName').textContent = SP.short[f]; paintBB(); $('#bbImg').src = IMGS[f];
    $('#finalPrice').textContent = P(f); $('#bbPrice').textContent = P(f);
  }
  $$('.card').forEach(c => c.addEventListener('click', e => { if(!e.target.closest('button')) setSel(c.dataset.finish); }));
  $$('.swatch').forEach(s => s.addEventListener('click', () => setSel(s.dataset.f)));
  /* card image view toggle — hover previews; click/tap makes an explicit selection */
  const canHover=matchMedia('(hover:hover) and (pointer:fine)');
  function selectedAlt(m){ return m.dataset.selectedView==='alt'; }
  function setCardView(m,alt,persist=true){
    if(persist) m.dataset.selectedView=alt?'alt':'main';
    m.classList.toggle('flip',alt);
    $$('.view-toggle button',m).forEach(b=>{
      const on=(b.dataset.view==='alt')===alt;
      b.classList.toggle('on',on);
      b.setAttribute('aria-pressed',String(on));
    });
  }
  $$('.view-toggle').forEach(t=>t.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    e.preventDefault();e.stopPropagation();setCardView(t.closest('.card-media'),b.dataset.view==='alt');
  }));
  $$('.card-media').forEach(m=>{
    m.dataset.selectedView=m.classList.contains('flip')?'alt':'main';
    m.addEventListener('click',e=>{
      if(e.target.closest('.view-toggle'))return;
      e.preventDefault();e.stopPropagation();setCardView(m,!selectedAlt(m));
    });
    m.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' '){e.preventDefault();setCardView(m,!selectedAlt(m));}
    });
    m.addEventListener('mouseenter',()=>{if(canHover.matches&&!selectedAlt(m))m.classList.add('flip');});
    m.addEventListener('mouseleave',()=>{if(canHover.matches)setCardView(m,selectedAlt(m),false);});
  });

  /* ---------- cart ---------- */
  const cart = new Map();
  const drawer = $('#drawer'), scrim = $('#scrim');
  function openCart(){ drawer.classList.add('show'); scrim.classList.add('show'); drawer.setAttribute('aria-hidden','false'); $('#closeCart').focus(); }
  function closeCart(){ drawer.classList.remove('show'); scrim.classList.remove('show'); drawer.setAttribute('aria-hidden','true'); }
  if($('#cartBtn')) $('#cartBtn').addEventListener('click', openCart); $('#closeCart').addEventListener('click', closeCart); scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if(e.key==='Escape') closeCart(); });
  let toastT;
  function toast(msg){ const t=$('#toast'); t.textContent=msg; t.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove('show'),2200); }
  /* same pattern as the theme's own SETPOINT section: add by AJAX, re-render the theme's cart drawer, open it */
  async function spThemeAdd(id){
    const root=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/');
    const drawer=document.querySelector('cart-drawer');
    const secs=(drawer&&typeof drawer.getSectionsToRender==='function')?drawer.getSectionsToRender().map(x=>x.id):['cart-drawer','cart-icon-bubble'];
    const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',
      body:JSON.stringify({id:Number(id),quantity:1,sections:secs.join(','),sections_url:location.pathname})});
    const state=await r.json(); if(!r.ok) throw new Error(state.description||'add failed');
    const html=state.sections&&state.sections['cart-drawer'];
    if(!html||html.indexOf('CartDrawer-Item-')===-1){
      const sr=await fetch(root+'cart?sections='+encodeURIComponent(secs.join(','))+'&_='+Date.now(),{headers:{'Accept':'application/json'},credentials:'same-origin',cache:'no-store'});
      state.sections=await sr.json();
    }
    if(drawer&&typeof drawer.renderContents==='function'&&state.sections&&state.sections['cart-drawer']){
      drawer.classList.remove('is-empty'); drawer.renderContents(state); drawer.classList.remove('is-empty');
      const di=drawer.querySelector('cart-drawer-items'); if(di) di.classList.remove('is-empty');
    } else { location.href=root+'cart'; }
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:state,source:'setpoint-nik'}}));
  }
  function add(k, btn){
    if(SP.variant && SP.variant[k]){
      const old = btn ? btn.innerHTML : '';
      if(btn){ btn.textContent=SP.t.added; btn.disabled=true; }
      spThemeAdd(SP.variant[k])
        .then(()=>{ if(btn) setTimeout(()=>{ btn.innerHTML=old; btn.disabled=false; paintBB(); },1400); })
        .catch(e=>{ console.error('[SETPOINT cart]',e); if(btn){ btn.innerHTML=old; btn.disabled=false; paintBB(); } toast(SP.t.cart_error); });
      return;
    }
    cart.set(k, (cart.get(k)||0)+1); renderCart();
    if(btn){ const old=btn.innerHTML; btn.textContent=SP.t.added; btn.disabled=true; setTimeout(()=>{btn.innerHTML=old;btn.disabled=false; paintBB();},1200); }
    toast(`${NAMES[k]} ${SP.t.added_toast}`);
  }
  function renderCart(){
    const items=$('#items'); let n=0, total=0; items.innerHTML='';
    if(!cart.size){ items.innerHTML=`<p class="empty">${SP.t.empty}</p>`; }
    cart.forEach((q,k) => {
      n+=q; const p=unit(k)*q; total+=p;
      const row=document.createElement('div'); row.className='line';
      row.innerHTML=`<img src="${IMGS[k]}" alt=""><div><b>${NAMES[k]}</b><span>${short(unit(k))} ${SP.t.each}${(BUNDLE[cur][k]!==undefined&&hasRazor())?' \u00b7 '+SP.t.bundle:''}</span><div class="qty"><button aria-label="Decrease quantity" data-d="-1">\u2212</button><output>${q}</output><button aria-label="Increase quantity" data-d="1">+</button></div></div><span class="p">${money(p)}</span>`;
      row.addEventListener('click', e => { const b=e.target.closest('button'); if(!b) return; const nq=q+Number(b.dataset.d); if(nq<=0) cart.delete(k); else cart.set(k,nq); renderCart(); });
      items.appendChild(row);
    });
    if($('#total')) $('#total').textContent = money(total);
    $$('[data-price]').forEach(el => { const k=el.dataset.price; if(BUNDLE[cur][k]!==undefined) el.textContent = short(hasRazor()?BUNDLE[cur][k]:PRICES[cur][k]); });
    $$('.upsell .price s').forEach(el => el.style.display = hasRazor()?'':'none');
    if($('#addBlades')) if($('#addBlades')) $('#addBlades').textContent = `Add blades to cart \u00b7 ${short(hasRazor()?BUNDLE[cur].blades:PRICES[cur].blades)}`;
    const c=$('#cartCount'); if(c){ c.textContent=n; c.classList.toggle('show', n>0); }
  }
  $$('[data-add]').forEach(b => b.addEventListener('click', () => { if(RAZORS.includes(b.dataset.add)) setSel(b.dataset.add); add(b.dataset.add, b); }));
  function requireFinish(btn){ if(sel){ add(sel,btn); return; } const target=$('#finishes'); if(target) target.scrollIntoView({behavior:'smooth',block:'start'}); }
  $('#bbAdd').addEventListener('click', e => requireFinish(e.currentTarget));
  $('#finalAdd').addEventListener('click', e => requireFinish(e.currentTarget));
  $('#addBlades')?.addEventListener('click', e => add('blades', e.currentTarget));
  $$('.card').forEach(c => c.classList.remove('selected'));
  $$('.swatch').forEach(s => { s.classList.remove('on'); s.setAttribute('aria-pressed','false'); });
  /* Preserve finish selection from Shopping, Meta and product redirects.
     Apply this after the default-state reset above so it remains selected. */
  const requestedVariant = new URLSearchParams(location.search).get('variant');
  if(requestedVariant && SP.variant){
    const requestedFinish = Object.keys(SP.variant).find(k => String(SP.variant[k]) === requestedVariant);
    if(requestedFinish && RAZORS.includes(requestedFinish)) setSel(requestedFinish);
  }
  paintPrices(); paintBB();

  /* sticky buy bar: show after the finishes section scrolls out, hide near the footer */
  const bb=$('#buybar'), fin=$('.cards'), foot=$('#promise');
  /* show once the three product cards have scrolled past; hide at the closing section (it has its own button) */
  const bbCheck=()=>{ const hr=(fin.closest('section')||document).querySelector('h2'); const r=(hr||fin).getBoundingClientRect(); const past=(r.top+r.height/2)<=innerHeight/2; const nearEnd=foot.getBoundingClientRect().top<innerHeight*0.9; bb.classList.toggle('show', past && !nearEnd); };
  addEventListener('scroll', bbCheck, {passive:true}); addEventListener('resize', bbCheck); bbCheck();

  /* ---------- hero video: YouTube first, Shopify fallback on error ---------- */
  const heroMedia=$('[data-hero-media]'), heroPoster=$('.sp-hero-poster'), hv=$('#heroVid'), sb=$('#soundBtn'), pb=$('#playBtn');
  const useYouTube=()=>!!(heroMedia&&heroMedia.dataset.desktopYoutubeId);
  let ytPlayer=null, heroReady=false;
  const revealHero=()=>{ heroReady=true; if(heroMedia) heroMedia.classList.add('sp-hero-ready'); };
  const showHeroFallback=()=>{
    if(!heroMedia||!hv) return;
    heroMedia.classList.add('sp-youtube-failed');
    loadVideo(hv);
    const reveal=()=>{ revealHero(); safePlay(hv,()=>{}); };
    if(hv.readyState>=2) reveal(); else hv.addEventListener('canplay',reveal,{once:true});
  };
  if(sb&&hv) sb.addEventListener('click', () => { loadVideo(hv); hv.muted=!hv.muted; sb.setAttribute('aria-pressed', !hv.muted); sb.querySelector('span').textContent = hv.muted ? SP.t.sound_on : SP.t.mute; if(!hv.muted) safePlay(hv,()=>{}); });
  if(pb&&hv) pb.addEventListener('click', () => { loadVideo(hv); if(hv.paused){ safePlay(hv,()=>{}); pb.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>'; pb.setAttribute('aria-label','Pause video'); } else { hv.pause(); pb.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'; pb.setAttribute('aria-label','Play video'); } });
  if(useYouTube()){
    let ready=false;
    const mount=()=>{
      if(!window.YT||!YT.Player) return;
      ytPlayer=new YT.Player('spHeroYouTube',{
        videoId:heroMedia.dataset.desktopYoutubeId,
        playerVars:{controls:1,playsinline:1,rel:0,modestbranding:1},
        events:{
          onReady:()=>{ready=true;heroMedia.classList.remove('sp-youtube-failed');unloadVideo(hv);revealHero();},
          onStateChange:e=>{ if(window.YT&&e.data===YT.PlayerState.PLAYING) revealHero(); },
          onError:showHeroFallback
        }
      });
    };
    if(window.YT&&YT.Player) mount(); else {
      const prior=window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady=()=>{if(typeof prior==='function')prior();mount();};
      if(!document.querySelector('script[data-sp-youtube-api]')){const y=document.createElement('script');y.src='https://www.youtube.com/iframe_api';y.async=true;y.dataset.spYoutubeApi='true';y.addEventListener('error',showHeroFallback,{once:true});document.head.appendChild(y);}
    }
  } else if(hv) showHeroFallback();
  if(heroMedia){
    new IntersectionObserver(([e])=>{
      if(!e.isIntersecting){
        try{ if(ytPlayer&&typeof ytPlayer.pauseVideo==='function') ytPlayer.pauseVideo(); }catch(err){}
        if(hv) hv.pause();
      }
    },{threshold:.05}).observe(heroMedia);
  }
  $$('[data-toggle]').forEach(b => b.addEventListener('click', () => { const v=document.getElementById(b.dataset.toggle); loadVideo(v); if(v.paused){ safePlay(v,()=>b.classList.add('needs-play')); b.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>'; } else { v.pause(); b.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'; } }));

  /* Load ordinary clips only near the viewport, release them after leaving. */
  const unloadTimers=new WeakMap();
  const vio = new IntersectionObserver(es => es.forEach(e => {
    const v=e.target;
    clearTimeout(unloadTimers.get(v));
    if(e.isIntersecting){
      loadVideo(v);
      if(v.id!=='scrubVid' && !v.closest('.stage[data-stage]')) safePlay(v,()=>{});
    } else {
      v.pause();
      if(v!==hv) unloadTimers.set(v,setTimeout(()=>unloadVideo(v),8000));
    }
  }), {threshold:.05,rootMargin:'300px 0px'});
  $$('video').forEach(v => { if(!v.closest('.stage[data-stage]') && v!==hv) vio.observe(v); });

  /* ---------- story steppers ----------
     Desktop: clip plays in the stage beside the list, auto-advances until someone taps.
     Phone: the clip moves inside the open step, one step open at a time, no auto-advance. */
  const stepMQ=matchMedia('(max-width: 899px)');
  const navH=()=>($('.nav')?.getBoundingClientRect().height||0);
  $$('[data-steps]').forEach(list => {
    const key=list.dataset.steps, stage=$(`.stage[data-stage="${key}"]`), home=stage.parentElement;
    const media=$$('[data-step]',stage), steps=$$('.step',list);
    let cur=steps.findIndex(st=>st.classList.contains('on')); if(cur<0) cur=0;
    let visible=false, picked=false;
    const bars=steps.map(st=>$('.st-bar b',st));
    /* tap-to-play */
    const auto = stage.dataset.autoplay==='true';
    const pbtn=document.createElement('button'); pbtn.type='button'; pbtn.className='sp-play'; pbtn.setAttribute('aria-label', (SP.t&&SP.t.play_clip)||'Play clip');
    pbtn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>'; stage.appendChild(pbtn);
    const playIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
    const pauseIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor"/><rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor"/></svg>';
    const showPlay=paused=>{ const m=media[cur], hasVideo=m&&m.tagName==='VIDEO'; pbtn.hidden=!hasVideo; pbtn.classList.toggle('is-playing',hasVideo&&!paused); pbtn.innerHTML=paused?playIcon:pauseIcon; pbtn.setAttribute('aria-label',paused?((SP.t&&SP.t.play_clip)||'Play clip'):'Pause clip'); stage.classList.toggle('sp-paused',!!paused); };
    const primeWindow=i=>media.forEach((m,j)=>{ if(m.tagName!=='VIDEO') return; if(j===i || (!saveData&&j===i+1)) loadVideo(m); else unloadVideo(m); });
    pbtn.addEventListener('click',e=>{ e.stopPropagation(); const m=media[cur]; if(!m||m.tagName!=='VIDEO') return; picked=true; if(m.paused){ safePlay(m,()=>showPlay(true)); } else m.pause(); });
    const setBar=(i,f)=>bars.forEach((b,j)=>b.style.width = j===i ? (f*100).toFixed(1)+'%' : '0%');
    function place(){
      const slot = stepMQ.matches ? $('.st-media',steps[cur]) : home;
      if(stage.parentElement!==slot) slot.appendChild(stage);
    }
    function run(){
      const m=media[cur];
      /* Keep the manual play control in sync as soon as a frame is selected.
         The stage can be re-parented on mobile/desktop before IntersectionObserver
         reports it visible; waiting for that callback left a valid video looking
         like an unplayable poster. */
      if(!auto) showPlay(m.tagName==='VIDEO' && m.paused);
      if(!visible) return;
      primeWindow(cur);
      if(!auto){ if(m.tagName!=='VIDEO') setBar(cur,0); return; }
      if(m.tagName==='VIDEO'){ m.currentTime=0; safePlay(m,()=>showPlay(true)); }
      else { const t0=performance.now(), hold=5000; const tick=now=>{ if(media[cur]!==m||!visible) return; const f=Math.min(1,(now-t0)/hold); setBar(cur,f); if(f<1) requestAnimationFrame(tick); else next(); }; requestAnimationFrame(tick); }
    }
    function next(){ if(picked || stepMQ.matches) run(); else go((cur+1)%media.length); }
    function go(i){
      media.forEach((m,j)=>{ m.classList.toggle('on',j===i); if(m.tagName==='VIDEO' && j!==i) m.pause(); });
      steps.forEach((st,j)=>{ st.classList.toggle('on',j===i); $('.st-h',st).setAttribute('aria-expanded', j===i); });
      cur=i; primeWindow(cur); place(); setBar(cur,0); run();
    }
    media.forEach((m,j)=>{ if(m.tagName!=='VIDEO') return;
      m.addEventListener('timeupdate',()=>{ if(j===cur && m.duration) setBar(j, m.currentTime/m.duration); });
      m.addEventListener('ended',()=>{ if(j!==cur) return; if(auto) next(); else { showPlay(true); setBar(j,1); } });
      m.addEventListener('play',()=>{ if(j===cur) showPlay(false); });
      m.addEventListener('pause',()=>{ if(j===cur && !m.ended) showPlay(true); });
      m.addEventListener('click',()=>{ if(j!==cur || auto) return; if(m.paused){ safePlay(m,()=>showPlay(true)); } else m.pause(); });
    });
    steps.forEach((st,j)=>$('.st-h',st).addEventListener('click',()=>{
      picked=true;
      if(j===cur && st.classList.contains('on')){ /* collapse the open step */
        st.classList.remove('on'); $('.st-h',st).setAttribute('aria-expanded','false');
        media.forEach(m=>{ if(m.tagName==='VIDEO') m.pause(); });
        if(stepMQ.matches && stage.parentElement!==home) home.appendChild(stage);
        return;
      }
      go(j);
      if(stepMQ.matches){
        requestAnimationFrame(()=>{ const top=st.getBoundingClientRect().top, nh=navH();
          if(top<nh+4 || top>innerHeight*0.45) window.scrollTo({top:scrollY+top-nh-12, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); });
      }
    }));
    new IntersectionObserver(([e])=>{ visible=e.isIntersecting; if(visible){ primeWindow(cur); run(); } else media.forEach(m=>m.tagName==='VIDEO'&&unloadVideo(m)); },{threshold:.05,rootMargin:'250px 0px'}).observe(stage);
    stepMQ.addEventListener('change',place);
    place();
  });

  /* ---------- face map ---------- */
  const zones=$$('.face-views .z'), zbtns=$$('.zone');
  function setZone(z){
    zones.forEach(p => { p.classList.toggle('on', p.dataset.zone===z); p.classList.toggle('dim', p.dataset.zone!==z); });
    zbtns.forEach(b => { const on=b.dataset.zone===z; b.classList.toggle('on',on); b.setAttribute('aria-pressed',on); });
  }
  const ZONE_SET={cheek:4,lip:3.5,neck:1.5};
  function pickZone(z){ setZone(z); const rr=$('#dialRange'); if(rr){ rr.value=ZONE_SET[z]; rr.dispatchEvent(new Event('input')); } }
  zones.forEach(p => { p.addEventListener('click', () => pickZone(p.dataset.zone)); p.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pickZone(p.dataset.zone);} }); p.addEventListener('mouseenter', () => setZone(p.dataset.zone)); });
  zbtns.forEach(b => { b.addEventListener('click', () => pickZone(b.dataset.zone)); b.addEventListener('mouseenter', () => setZone(b.dataset.zone)); });
  setZone('cheek');


  /* ---------- last-shave calendar ---------- */
  (function(){
    const strip=$('#strip'); if(!strip) return;
    const WD=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const today=new Date(); let last=3;
    const dayOf=k=>{ const d=new Date(today); d.setDate(today.getDate()-k); return d; };
    const setFor=g=>Math.min(6,3+(g-1)*0.5);
    const gapFor=v=>0.30+0.16*(v-1);
    const fmt=v=>Number.isInteger(v)?String(v):v.toFixed(1);
    const hairs=$('#hairs');
    const HX=[12,30,47,66,83,101,118,137,154,172,189], LEAN=[4,-3,6,2,-4,5,-2,3,6,-3,4], JIT=[1,.86,.95,1.08,.9,1.04,.92,1,.88,1.06,.97];
    function drawHairs(g){
      const L=6+g*10.5;
      hairs.innerHTML=HX.map((x,i)=>{ const l=L*JIT[i], lean=LEAN[i]*(0.4+g/7); return `<path d="M${x},86 q${(lean*0.4).toFixed(1)},${(-l*0.55).toFixed(1)} ${lean.toFixed(1)},${(-l).toFixed(1)}"/>`; }).join('');
    }
    function render(){
      strip.innerHTML='';
      for(let k=7;k>=0;k--){
        const d=dayOf(k), isToday=k===0;
        const el=document.createElement(isToday?'div':'button');
        if(!isToday) el.type='button';
        let cls='cell', tag='';
        if(isToday){ cls+=' today'; tag=`<b>${fmt(setFor(last))}</b>`; }
        else if(k===last){ cls+=' shaved'; tag='Shaved'; }
        else if(k<last){ cls+=' grow'; tag=`+${last-k}d`; }
        else { cls+=' before'; }
        el.className=cls;
        el.innerHTML=`<span class="wd">${isToday?'Today':WD[d.getDay()].slice(0,3)}</span><span class="dt">${d.getDate()}</span><span class="tag">${tag}</span>`;
        if(isToday){ el.setAttribute('aria-label',`Today: start at ${fmt(setFor(last))}`); }
        else { el.setAttribute('aria-pressed',k===last); el.setAttribute('aria-label',`${WD[d.getDay()]} ${d.getDate()}, ${k} day${k===1?'':'s'} ago`); el.addEventListener('click',()=>{ last=k; render(); }); }
        strip.appendChild(el);
      }
      const v=setFor(last), lastDay=WD[dayOf(last).getDay()];
      $('#calGrow').textContent= last===1 ? 'Last shaved yesterday' : `Last shaved ${last===7?'a week ago':lastDay}`;
      $('#stubbleCap').textContent=`${last} day${last===1?'':'s'} of stubble`;
      $('#calSet').textContent=fmt(v);
      $('#calMm').textContent=`Blade gap ${gapFor(v).toFixed(2)} mm`;
      $('#calToDial').textContent=`Set the dial to ${fmt(v)}`;
      drawHairs(last);
    }
    $('#calToDial').addEventListener('click',()=>{ const r=$('#dialRange'); if(r){ r.value=setFor(last); r.dispatchEvent(new Event('input')); } });
    render();
  })();


  /* ---------- assembly: tap a step to jump the film; the current step lights up ---------- */
  (function(){
    const v=$('#asmVid'), list=$('#asmSteps'); if(!v||!list) return;
    const btns=$$('button',list), T=btns.map(b=>parseFloat(b.dataset.t));
    const mark=()=>{ let k=-1; T.forEach((t,i)=>{ if(v.currentTime>=t-0.05) k=i; }); btns.forEach((b,i)=>{ b.classList.toggle('on',i===k); b.setAttribute('aria-current', i===k ? 'step' : 'false'); }); };
    v.addEventListener('timeupdate',mark);
    btns.forEach((b,i)=>b.addEventListener('click',()=>{ loadVideo(v); const go=()=>{ v.currentTime=T[i]; safePlay(v,()=>{}); mark(); }; if(v.readyState>=1) go(); else { v.addEventListener('loadedmetadata',go,{once:true}); v.load(); } }));
  })();

  /* ---------- dial guide ---------- */
  const r=$('#dialRange'), bands=$$('.bands button');
  const BANDS=bands.map(b=>({lo:parseFloat(b.dataset.min),hi:parseFloat(b.dataset.max),n:b.dataset.name,d:b.dataset.desc}));
  function paintDial(){
    const s=Number(r.value), gap=0.30+0.16*(s-1);
    $('#setVal').textContent=s.toFixed(1);
    $('#gapVal').textContent=gap.toFixed(2)+' mm';
    $('#bladeLine').style.setProperty('--gap', (8+ (gap-0.30)/0.80*48).toFixed(1)+'px');
    $('.gapviz').style.setProperty('--gap', (8+ (gap-0.30)/0.80*48).toFixed(1)+'px');
    const b=BANDS.find(x=>s>=x.lo&&s<=x.hi)||BANDS[bands.findIndex(x=>x.classList.contains('on'))]||BANDS[0];
    $('#bandName').firstChild.textContent=b.n; $('#bandDesc').textContent=b.d;
    bands.forEach((x,i)=>x.classList.toggle('on', BANDS[i]===b));
    r.setAttribute('aria-valuetext', `Setting ${s.toFixed(1)}, blade gap ${gap.toFixed(2)} mm`);
    const si=$('#scrubImg'); if(si){ const k=Math.round((s-1)*10); si.src=SP.dialFrame.replace('s00.webp', `s${String(k).padStart(2,'0')}.webp`); }
  }
  const dg=$('#dial'); if(dg){ const warm=new IntersectionObserver(es=>{ if(es.some(e=>e.isIntersecting)){ for(let k=0;k<=50;k++){ const im=new Image(); im.src=SP.dialFrame.replace('s00.webp', `s${String(k).padStart(2,'0')}.webp`); } warm.disconnect(); } },{rootMargin:'600px'}); warm.observe(dg); }
  r.addEventListener('input', paintDial);
  bands.forEach(b => b.addEventListener('click', () => { r.value=b.dataset.band; paintDial(); }));
  paintDial();

  /* ---------- reveal on scroll (visible at rest, animates in) ---------- */
  if(matchMedia('(prefers-reduced-motion: no-preference)').matches){
    const rv=$$('.rv'); rv.forEach(el => { if(el.getBoundingClientRect().top>innerHeight) el.classList.add('pre'); });
    const ro=new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.remove('pre'); ro.unobserve(e.target);} }),{threshold:.12});
    rv.forEach(el=>ro.observe(el));
  }

  /* ---------- keep the buy bar above Shopify's preview bar (preview mode only) ---------- */
  (function(){
    const bar=$('#buybar'); if(!bar) return;
    const lift=()=>{ const pb=document.getElementById('PBarNextFrameWrapper');
      const h = pb && getComputedStyle(pb).display!=='none' ? Math.round(pb.getBoundingClientRect().height) : 0;
      bar.style.bottom = h ? h+'px' : ''; };
    lift(); setTimeout(lift,1500); setTimeout(lift,4000);
    if('ResizeObserver' in window){ const t=setInterval(()=>{ const pb=document.getElementById('PBarNextFrameWrapper'); if(pb){ new ResizeObserver(lift).observe(pb); clearInterval(t); } },500); setTimeout(()=>clearInterval(t),10000); }
  })();

  /* Native CSS text wrapping is used; forced non-breaking spaces caused clipped mobile lines. */
})();
